import loadable from '@loadable/component';

export default loadable(
    () => import(/* webpackChunkName: "ActiveCartReminderChunksLazy" */ './ActiveCartReminder'),
    { fallback: null }
);
